"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _Tab = _interopRequireDefault(require("./Tab"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var arrowIcons = {
  left: /*#__PURE__*/_react["default"].createElement("svg", {
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
  })),
  right: /*#__PURE__*/_react["default"].createElement("svg", {
    focusable: "false",
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
  }))
};

var useResize = function useResize(refTabList) {
  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      viewWidth = _useState2[0],
      setViewWidth = _useState2[1];

  var handleWindowSizeChange = (0, _react.useCallback)(function () {
    var _refTabList$current;

    setViewWidth(refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current = refTabList.current) === null || _refTabList$current === void 0 ? void 0 : _refTabList$current.offsetWidth);
  }, [refTabList]);
  (0, _react.useEffect)(function () {
    window.addEventListener("load", handleWindowSizeChange);
    window.addEventListener("resize", handleWindowSizeChange);
    return function () {
      window.removeEventListener("load", handleWindowSizeChange);
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, [handleWindowSizeChange]);
  return viewWidth;
};

var DxcTabs = function DxcTabs(_ref) {
  var defaultActiveTabIndex = _ref.defaultActiveTabIndex,
      activeTabIndex = _ref.activeTabIndex,
      tabs = _ref.tabs,
      onTabClick = _ref.onTabClick,
      onTabHover = _ref.onTabHover,
      margin = _ref.margin,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? "top" : _ref$iconPosition,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? 0 : _ref$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();
  var hasLabelAndIcon = tabs && tabs.filter(function (tab) {
    return tab.label && tab.icon;
  }).length > 0;
  var firstFocus = tabs && tabs.findIndex(function (tab) {
    return !tab.isDisabled;
  });

  var _useState3 = (0, _react.useState)(tabs && defaultActiveTabIndex && !tabs[defaultActiveTabIndex].isDisabled ? defaultActiveTabIndex : firstFocus),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      innerActiveTabIndex = _useState4[0],
      setInnerActiveTabIndex = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      activeIndicatorWidth = _useState6[0],
      setActiveIndicatorWidth = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      activeIndicatorLeft = _useState8[0],
      setActiveIndicatorLeft = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      translateScroll = _useState10[0],
      setTranslateScroll = _useState10[1];

  var _useState11 = (0, _react.useState)(true),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      scrollRightEnabled = _useState12[0],
      setScrollRightEnabled = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      scrollLeftEnabled = _useState14[0],
      setScrollLeftEnabled = _useState14[1];

  var _useState15 = (0, _react.useState)(0),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      countClick = _useState16[0],
      setCountClick = _useState16[1];

  var _useState17 = (0, _react.useState)(0),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      totalTabsWidth = _useState18[0],
      setTotalTabsWidth = _useState18[1];

  var _useState19 = (0, _react.useState)(activeTabIndex !== null && activeTabIndex !== void 0 ? activeTabIndex : innerActiveTabIndex),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      currentFocusIndex = _useState20[0],
      setCurrentFocusIndex = _useState20[1];

  var _useState21 = (0, _react.useState)(activeTabIndex !== null && activeTabIndex !== void 0 ? activeTabIndex : innerActiveTabIndex),
      _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
      temporalFocusIndex = _useState22[0],
      setTemporalFocusIndex = _useState22[1];

  var _useState23 = (0, _react.useState)(0),
      _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
      minHeightTabs = _useState24[0],
      setMinHeightTabs = _useState24[1];

  var refTabs = (0, _react.useRef)([]);
  var refTabList = (0, _react.useRef)(null);
  var viewWidth = useResize(refTabList);
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var enabledIndicator = (0, _react.useMemo)(function () {
    return viewWidth < totalTabsWidth;
  }, [viewWidth]);
  (0, _react.useEffect)(function () {
    var _refTabs$current, _refTabs$current2, _refTabs$current3;

    var sumWidth = refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current = refTabs.current) === null || _refTabs$current === void 0 ? void 0 : _refTabs$current.reduce(function (count, obj) {
      return count + obj.offsetWidth;
    }, 0);
    setTotalTabsWidth(sumWidth);
    setActiveIndicatorWidth(refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current2 = refTabs.current[activeTabIndex !== null && activeTabIndex !== void 0 ? activeTabIndex : innerActiveTabIndex]) === null || _refTabs$current2 === void 0 ? void 0 : _refTabs$current2.offsetWidth);
    setActiveIndicatorLeft(refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current3 = refTabs.current[activeTabIndex !== null && activeTabIndex !== void 0 ? activeTabIndex : innerActiveTabIndex]) === null || _refTabs$current3 === void 0 ? void 0 : _refTabs$current3.offsetLeft);
  }, [refTabs]);
  (0, _react.useEffect)(function () {
    var _refTabList$current2;

    setMinHeightTabs((refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current2 = refTabList.current) === null || _refTabList$current2 === void 0 ? void 0 : _refTabList$current2.offsetHeight) + 1);
  }, [refTabList]);
  (0, _react.useEffect)(function () {
    if (activeTabIndex >= 0) {
      var _refTabs$current$acti, _refTabs$current$acti2;

      setActiveIndicatorWidth(refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current$acti = refTabs.current[activeTabIndex]) === null || _refTabs$current$acti === void 0 ? void 0 : _refTabs$current$acti.offsetWidth);
      setActiveIndicatorLeft(refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current$acti2 = refTabs.current[activeTabIndex]) === null || _refTabs$current$acti2 === void 0 ? void 0 : _refTabs$current$acti2.offsetLeft);
    }
  }, [activeTabIndex]);

  var handleSelected = function handleSelected(newValue) {
    activeTabIndex !== null && activeTabIndex !== void 0 ? activeTabIndex : setInnerActiveTabIndex(newValue);
    onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(newValue);

    if (activeTabIndex === undefined) {
      var _refTabs$current$newV, _refTabs$current$newV2;

      setActiveIndicatorWidth(refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current$newV = refTabs.current[newValue]) === null || _refTabs$current$newV === void 0 ? void 0 : _refTabs$current$newV.offsetWidth);
      setActiveIndicatorLeft(refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current$newV2 = refTabs.current[newValue]) === null || _refTabs$current$newV2 === void 0 ? void 0 : _refTabs$current$newV2.offsetLeft);
    }
  };

  var scrollLeft = function scrollLeft() {
    var _refTabList$current3;

    var scrollWidth = (refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current3 = refTabList.current) === null || _refTabList$current3 === void 0 ? void 0 : _refTabList$current3.offsetWidth) * 0.75;
    var moveX;

    if (countClick <= scrollWidth) {
      moveX = 0;
      setScrollLeftEnabled(false);
      setScrollRightEnabled(true);
    } else {
      moveX = countClick - scrollWidth;
      setScrollRightEnabled(true);
      setScrollLeftEnabled(true);
    }

    setTranslateScroll(-moveX);
    setCountClick(moveX);
  };

  var scrollRight = function scrollRight() {
    var _refTabList$current4, _refTabList$current5;

    var scrollWidth = (refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current4 = refTabList.current) === null || _refTabList$current4 === void 0 ? void 0 : _refTabList$current4.offsetWidth) * 0.75;
    var moveX;

    if (countClick + scrollWidth + (refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current5 = refTabList.current) === null || _refTabList$current5 === void 0 ? void 0 : _refTabList$current5.offsetWidth) >= totalTabsWidth) {
      var _refTabList$current6;

      moveX = totalTabsWidth - (refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current6 = refTabList.current) === null || _refTabList$current6 === void 0 ? void 0 : _refTabList$current6.offsetWidth);
      setScrollRightEnabled(false);
      setScrollLeftEnabled(true);
    } else {
      moveX = countClick + scrollWidth;
      setScrollLeftEnabled(true);
      setScrollRightEnabled(true);
    }

    setTranslateScroll(-moveX);
    setCountClick(moveX);
  };

  var setPreviousTabFocus = function setPreviousTabFocus() {
    setTemporalFocusIndex(function (temporalFocusIndex) {
      var index = temporalFocusIndex === 0 ? tabs.length - 1 : temporalFocusIndex - 1;

      while (tabs[index].isDisabled) {
        index = index === 0 ? tabs.length - 1 : index - 1;
      }

      refTabs === null || refTabs === void 0 ? void 0 : refTabs.current[index].focus({
        preventScroll: true
      });
      setScrollFocus(index);
      return index;
    });
  };

  var setNextTabFocus = function setNextTabFocus() {
    setTemporalFocusIndex(function (temporalFocusIndex) {
      var index = temporalFocusIndex === tabs.length - 1 ? 0 : temporalFocusIndex + 1;

      while (tabs[index].isDisabled) {
        index = index === tabs.length - 1 ? 0 : index + 1;
      }

      refTabs === null || refTabs === void 0 ? void 0 : refTabs.current[index].focus({
        preventScroll: true
      });
      setScrollFocus(index);
      return index;
    });
  };

  var setScrollFocus = function setScrollFocus(actualIndex) {
    var _refTabs$current4, _refTabList$current8;

    var sumPrev = 0;
    refTabs === null || refTabs === void 0 ? void 0 : (_refTabs$current4 = refTabs.current) === null || _refTabs$current4 === void 0 ? void 0 : _refTabs$current4.map(function (item, index) {
      if (index <= actualIndex) {
        sumPrev += item.offsetWidth;
      }
    });
    var moveX = 0;

    if (actualIndex === tabs.length - 1) {
      var _refTabList$current7;

      moveX = totalTabsWidth - (refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current7 = refTabList.current) === null || _refTabList$current7 === void 0 ? void 0 : _refTabList$current7.offsetWidth);
      setScrollLeftEnabled(true);
      setScrollRightEnabled(false);
    } else if (sumPrev > (refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current8 = refTabList.current) === null || _refTabList$current8 === void 0 ? void 0 : _refTabList$current8.offsetWidth)) {
      var _refTabList$current9;

      moveX = sumPrev - (refTabList === null || refTabList === void 0 ? void 0 : (_refTabList$current9 = refTabList.current) === null || _refTabList$current9 === void 0 ? void 0 : _refTabList$current9.offsetWidth) + 1; //plus 1px for the outline

      setScrollLeftEnabled(true);
      setScrollRightEnabled(true);
    } else {
      setScrollLeftEnabled(false);
      setScrollRightEnabled(true);
    }

    setTranslateScroll(-moveX);
    setCountClick(moveX);
  };

  var handleOnKeyDown = function handleOnKeyDown(event) {
    switch (event.key) {
      case "Left":
      case "ArrowLeft":
        event.preventDefault();
        setPreviousTabFocus();
        break;

      case "Right":
      case "ArrowRight":
        event.preventDefault();
        setNextTabFocus();
        break;

      case "Enter":
      case " ":
        event.preventDefault();
        setCurrentFocusIndex(temporalFocusIndex);
        handleSelected(temporalFocusIndex);
        break;

      case "Tab":
        if (temporalFocusIndex !== currentFocusIndex) {
          event.preventDefault();
          setTemporalFocusIndex(currentFocusIndex);
          refTabs === null || refTabs === void 0 ? void 0 : refTabs.current[currentFocusIndex].focus();
        }

        handleSelected(currentFocusIndex);
        break;
    }
  };

  var isTabActive = function isTabActive(index) {
    return activeTabIndex >= 0 ? activeTabIndex === index : innerActiveTabIndex === index;
  };

  var isActiveIndicatorDisabled = firstFocus === -1 || tabs && activeTabIndex >= 0 && tabs[activeTabIndex].isDisabled;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.tabs
  }, /*#__PURE__*/_react["default"].createElement(TabsContainer, {
    margin: margin
  }, /*#__PURE__*/_react["default"].createElement(Underline, null), /*#__PURE__*/_react["default"].createElement(Tabs, {
    hasLabelAndIcon: hasLabelAndIcon,
    iconPosition: iconPosition
  }, /*#__PURE__*/_react["default"].createElement(ScrollIndicator, {
    onClick: scrollLeft,
    scrollLeftEnabled: scrollLeftEnabled,
    enabled: enabledIndicator,
    "aria-disabled": !scrollLeftEnabled,
    "aria-label": translatedLabels.tabs.scrollLeft,
    tabIndex: scrollLeftEnabled ? tabIndex : -1,
    minHeightTabs: minHeightTabs
  }, arrowIcons.left), /*#__PURE__*/_react["default"].createElement(TabsContent, null, /*#__PURE__*/_react["default"].createElement(TabsContentScroll, {
    translateScroll: translateScroll,
    ref: refTabList,
    enabled: enabledIndicator
  }, /*#__PURE__*/_react["default"].createElement(TabList, {
    role: "tablist",
    onKeyDown: handleOnKeyDown,
    minHeightTabs: minHeightTabs
  }, tabs.map(function (tab, i) {
    return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
      tab: tab,
      key: "tab".concat(i).concat(tab.label),
      active: isTabActive(i),
      tabIndex: isTabActive(i) && !tab.isDisabled ? tabIndex : -1,
      hasLabelAndIcon: hasLabelAndIcon,
      iconPosition: iconPosition,
      ref: function ref(el) {
        return refTabs.current[i] = el;
      },
      onClick: function onClick() {
        setCurrentFocusIndex(i);
        setTemporalFocusIndex(i);
        handleSelected(i);
      },
      onMouseEnter: function onMouseEnter() {
        onTabHover === null || onTabHover === void 0 ? void 0 : onTabHover(i);
      },
      onMouseLeave: function onMouseLeave() {
        onTabHover === null || onTabHover === void 0 ? void 0 : onTabHover(null);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement(ActiveIndicator, {
    tabWidth: activeIndicatorWidth,
    tabLeft: activeIndicatorLeft,
    "aria-disabled": isActiveIndicatorDisabled
  }))), /*#__PURE__*/_react["default"].createElement(ScrollIndicator, {
    onClick: scrollRight,
    scrollRightEnabled: scrollRightEnabled,
    enabled: enabledIndicator,
    "aria-disabled": !scrollRightEnabled,
    "aria-label": translatedLabels.tabs.scrollRight,
    tabIndex: scrollRightEnabled ? tabIndex : -1,
    minHeightTabs: minHeightTabs
  }, arrowIcons.right))));
};

var Underline = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  position: absolute;\n  height: ", ";\n  background-color: ", ";\n  z-index: 1;\n"])), function (props) {
  return props.theme.dividerThickness;
}, function (props) {
  return props.theme.dividerColor;
});

var TabsContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var Tabs = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  min-height: ", ";\n  height: ", ";\n  display: flex;\n  overflow: hidden;\n  background-color: ", ";\n"])), function (props) {
  return (!props.hasLabelAndIcon || props.hasLabelAndIcon && props.iconPosition !== "top") && "48px" || "72px";
}, function (props) {
  return (!props.hasLabelAndIcon || props.hasLabelAndIcon && props.iconPosition !== "top") && "48px" || "72px";
}, function (props) {
  return props.theme.unselectedBackgroundColor;
});

var ScrollIndicator = _styledComponents["default"].button(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: ", ";\n  background-color: #ffffff;\n  font-size: 1.25rem;\n  min-width: ", ";\n  height: ", "px;\n  padding: 0;\n  justify-content: center;\n  cursor: pointer;\n  border-bottom: solid ", " ", ";\n  box-sizing: border-box;\n  border: none;\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    outline: ", " solid 1px;\n    outline-offset: -1px;\n  }\n  &:active {\n    background-color: ", ";\n  }\n  svg {\n    height: 20px;\n    width: 20px;\n    align-self: center;\n    fill: ", ";\n    visibility: visible;\n  }\n  &[aria-disabled=\"true\"] {\n    pointer-events: none;\n    cursor: default;\n    svg {\n      visibility: hidden;\n    }\n    &:focus {\n      outline: none;\n    }\n    &:hover,\n    &:active {\n      background-color: transparent !important;\n    }\n  }\n"])), function (props) {
  return props.enabled ? "flex" : "none";
}, function (props) {
  return props.theme.scrollButtonsWidth;
}, function (props) {
  return props.minHeightTabs - 1;
}, function (props) {
  return props.theme.dividerThickness;
}, function (props) {
  return props.theme.dividerColor;
}, function (props) {
  return "".concat(props.theme.hoverBackgroundColor, " !important");
}, function (props) {
  return props.theme.focusOutline;
}, function (props) {
  return "".concat(props.theme.pressedBackgroundColor, " !important");
}, function (props) {
  return props.theme.unselectedFontColor;
});

var ActiveIndicator = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  left: ", ";\n  width: ", ";\n  z-index: 2;\n  background-color: ", ";\n  bottom: 0;\n  height: ", ";\n  position: absolute;\n  &[aria-disabled=\"true\"] {\n    background-color: ", ";\n    display: none;\n  }\n"])), function (props) {
  return "".concat(props.tabLeft, "px");
}, function (props) {
  return "".concat(props.tabWidth, "px");
}, function (props) {
  return props.theme.selectedUnderlineColor;
}, function (props) {
  return props.theme.selectedUnderlineThickness;
}, function (props) {
  return props.theme.disabledFontColor;
});

var TabsContent = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  z-index: 1;\n  flex: 1 1 auto;\n  display: inline-block;\n  position: relative;\n  white-space: nowrap;\n  overflow-x: scroll;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])));

var TabList = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  min-height: ", "px;\n"])), function (props) {
  return props.minHeightTabs;
});

var TabsContentScroll = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  ", ";\n  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"])), function (props) {
  return props.enabled ? "transform: translateX(".concat(props.translateScroll, "px)") : "transform: translateX(0px)";
});

var _default = DxcTabs;
exports["default"] = _default;